module.exports = __webpack_public_path__ + "img/picture.ed050fbe.png";